import styled from 'styled-components'

const IconPopoverUi = styled.div`
  position: absolute;
  top: 40px;
  left: 0;
  padding-bottom: 2px;
  text-align: left;
  width: 315px;
  background: #fff;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  max-width: 340px;
  z-index: var(--z-index-popover);
`
export default IconPopoverUi
